import AxiosService from './../Services/AxiosService';
export default async function initializeApplication(): Promise<number> {
    const axios = new AxiosService();
    const result = await axios.axiosInstance.get('config.json?v=' + new Date().toISOString());
    window.$config = result.data || {};
    window.$config.EnableSenderTemplate = false;
    window.$config.messageTemplateRegulationsPdfUrl = '';
    window.$config.messageTemplateVipPackage = false;
    window.$config.messageTemplateSpeedUpApprovalHide = true;
    window.$config.messageTemplatePaymentPhaseEnabled = false;
    window.$config.messageTemplateSpeedUpFeeAmount = 10;
    window.$config.messageTemplateExpiryDateHidden = true;
    window.$config.messageTemplateDaysLeftHidden = true;
    window.$config.EnableTemplateFilterCheck = false;

    try {
        const features = await axios.axiosInstance.get('api/client-features');
        if (features && features.data) {
            window.$config.EnableSenderTemplate = features.data.enableSenderTemplate === true;
            window.$config.messageTemplateRegulationsPdfUrl = features.data.messageTemplateRegulationsPdfUrl || '';
            window.$config.messageTemplateVipPackage = features.data.messageTemplateVipPackage === true;
            window.$config.messageTemplateSpeedUpApprovalHide = features.data.messageTemplateSpeedUpApprovalHide !== false;
            window.$config.messageTemplatePaymentPhaseEnabled = features.data.messageTemplatePaymentPhaseEnabled === true;
            window.$config.messageTemplateSpeedUpFeeAmount = features.data.messageTemplateSpeedUpFeeAmount || 10;
            window.$config.messageTemplateExpiryDateHidden = features.data.messageTemplateExpiryDateHidden !== false;
            window.$config.messageTemplateDaysLeftHidden = features.data.messageTemplateDaysLeftHidden !== false;
            window.$config.EnableTemplateFilterCheck = features.data.enableTemplateFilterCheck === true;
        }
    } catch (error) {
        window.$config.EnableSenderTemplate = false;
        window.$config.EnableTemplateFilterCheck = false;
    }

    const p = Promise.resolve(1);
    return p;
}
